import {
  SIZE_CLASS_LG,
  SIZE_CLASS_MD,
  SIZE_CLASS_SM,
  SIZE_CLASS_XL,
  SIZE_CLASS_XS,
  SIZE_CLASS_XXL,
} from '../definition/business';

export function getSizeClass(innerWidth) {
  if (innerWidth > 1200) {
    return SIZE_CLASS_XL;
  }
  if (innerWidth > 992) {
    return SIZE_CLASS_LG;
  }
  if (innerWidth > 768) {
    return SIZE_CLASS_MD;
  }
  return SIZE_CLASS_SM;
}

export function isBigEnough(currentClass) {
  return (
    currentClass === SIZE_CLASS_LG ||
    currentClass === SIZE_CLASS_XL ||
    currentClass === SIZE_CLASS_XXL
  );
}



// WEBPACK FOOTER //
// ./src/public/journey1/helper/uiHelper.js